import QueryScreen from './QueryScreen.js';

export const QueryScreenConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: true
                },
                toolbar: {
                    display: true
                },
                footer: {
                    display: false
                }
            }
        }
    },
    routes: [
        {
            path: '/query-group',
            component: QueryScreen
        }
    ]
};


// WEBPACK FOOTER //
// ./src/main/content/query/QueryScreenConfig.js